import { PortalState } from '../../../../redux/store'

export const getIsVerifyingSignUp = (state: PortalState): boolean => state.signUpVerify.isVerifyingSignUp

export const getVerifySignUpErrorMessage = (state: PortalState): string => state.signUpVerify.verifySignUpErrorMessage
